import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M19.29 17.29L18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.62999 5.36 5.99999 7.92 5.99999 11V16L4.70999 17.29C4.07999 17.92 4.51999 19 5.40999 19H18.58C19.48 19 19.92 17.92 19.29 17.29ZM16 17H7.99999V11C7.99999 8.52 9.50999 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17ZM12 22C13.1 22 14 21.1 14 20H9.99999C9.99999 21.1 10.89 22 12 22Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.56506 2.50006C8.56506 2.18802 8.3121 1.93506 8.00006 1.93506C7.68802 1.93506 7.43506 2.18802 7.43506 2.50006V2.96368C6.06901 3.10667 5.17913 3.77154 4.6438 4.64147C4.06437 5.58306 3.93499 6.70546 3.93499 7.50011V10.5928L2.8213 10.9641C2.55842 11.0518 2.39789 11.3171 2.44229 11.5906C2.48668 11.8642 2.72288 12.0651 2.99999 12.0651H5.96737C6.01337 12.4421 6.11562 12.8249 6.31796 13.156C6.65183 13.7023 7.2155 14.0377 8.00006 14.0377C8.78462 14.0377 9.34828 13.7023 9.68216 13.156C9.8845 12.8249 9.98675 12.4421 10.0327 12.0651H13C13.2771 12.0651 13.5133 11.8642 13.5577 11.5906C13.6021 11.3171 13.4416 11.0518 13.1787 10.9641L12.065 10.5928V7.50011C12.065 6.70546 11.9356 5.58306 11.3562 4.64147C10.8209 3.77158 9.93102 3.10672 8.56506 2.96369V2.50006ZM7.28216 12.5667C7.20298 12.4371 7.14534 12.2679 7.10944 12.0651H8.89068C8.85477 12.2679 8.79714 12.4371 8.71796 12.5667C8.60183 12.7567 8.4155 12.9077 8.00006 12.9077C7.58462 12.9077 7.39828 12.7567 7.28216 12.5667ZM5.06499 7.50011V10.9351H10.935V7.50011C10.935 6.79476 10.8144 5.91713 10.3938 5.2337C9.99965 4.5932 9.30962 4.06506 7.99999 4.06506C6.69035 4.06506 6.00033 4.59319 5.60618 5.23369C5.18561 5.91713 5.06499 6.79475 5.06499 7.50011Z"
  />
);

export const NotificationIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Notification" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
